module.exports = {
    Handler: require('./ProjectReportHandler'),
    Dashboard: require('./ProjectReportsDashboard'),
    ProjectDashboard: require('./ProjectReportDashboard'),
    Agents: require('./ProjectReportAgentDashboard'),
    Performance: require('./ProjectReportPerformanceDashboard')
};
